import React from 'react';
import DropDown from '../DropDown/DropDown';

type Props = {
  defaultCurrency: string;
  id: string;
};

const CurrencyComponent = ({ defaultCurrency, id }: Props) => (
  <DropDown
    id={id}
    name="currency"
    items={[defaultCurrency]} // Use currencySymbols from '../../utils/getCurrencySymbol' when we will introduce more options than GBP
    handleChange={() => {}}
    defaultCurrency={defaultCurrency}
  />
);

export default CurrencyComponent;
